import { Suspense } from 'react';

import { useRouteHandleComponent } from '../useRouteHandleComponent';

/**
 * Renders the component named "ResourceSettings" from the deepest matching route module's "handle" export,
 * passing the "data" property (if any) from that same route handle object as a prop to the component.
 */
export function ResourceSettings() {
  const result = useRouteHandleComponent({ name: 'ResourceSettings' });

  if (result === undefined) {
    return null;
  }

  const { Component: RouteResourceSettings, data } = result;

  return (
    <Suspense fallback={null}>
      <RouteResourceSettings data={data} />
    </Suspense>
  );
}
